import { useSelector } from 'react-redux';
import { get } from 'lodash';
import JsonViewer from 'components/shared/JsonViewer/JsonViewer';
import DropModal from 'components/shared/DropModal/DropModal';
import { ChevronDownIcon, ChevronUpIcon } from 'components/icons';
import styles from './DMActionsTable.module.css';

export const RUNTIME_STATUSES = [
  'Completed',
  'Running',
  'Pending',
  'Canceled',
  'ContinuedAsNew',
  'Failed',
  'Terminated'
];

export const generateFiltersBarData = (deviceIds, statuses, dateRange) => [
  {
    id: 'device_id',
    title: 'Device ID',
    type: 'string',
    options: deviceIds,
    selection: deviceIds.reduce((acc, deviceId) => {
      acc[deviceId] = { selected: false };
      return acc;
    }, {})
  },
  {
    id: 'date',
    title: 'Dates',
    type: 'date',
    options: [],
    selection: dateRange
  },
  {
    id: 'status',
    title: 'Status',
    type: 'string',
    options: RUNTIME_STATUSES,
    selection: RUNTIME_STATUSES.reduce((acc, status) => {
      const selected = statuses.includes(status) ? true : false;
      acc[status] = { selected: selected };
      return acc;
    }, {})
  }
];

export const DMActionsTableCols = () => {
  return [
    {
      id: 'command',
      sortable: true,
      minWidth: 100,
      accessor: (action) => get(action, 'input.method', get(action, 'name')) || 'N/A',
      Header: 'Command',
      Cell: (row) => {
        const action = row.original;
        const commandName = get(action, 'input.method', get(action, 'name')) || 'N/A';
        const instanceId = get(action, 'instanceId');
        const dropModalName = `command_${instanceId}`;
        const isOpen = useSelector((state) => state.ui.sharedPages.dropModals?.[dropModalName]);

        const title = (
          <div className={styles.commandTitle}>
            <span className={styles.commandTitleTextOverflow}>{commandName}</span>
            {isOpen ? (
              <ChevronUpIcon size="small" className={styles.commandTitleIcon} />
            ) : (
              <ChevronDownIcon size="small" className={styles.commandTitleIcon} />
            )}
          </div>
        );
        return (
          <div className={styles.dropModalRoot} data-tip={commandName}>
            <DropModal title={title} name={dropModalName}>
              {isOpen && <JsonViewer jsonData={action} key={action?.instanceId} />}
            </DropModal>
          </div>
        );
      },
      className: styles.cell
    },
    {
      id: 'device_id',
      sortable: true,
      minWidth: 120,
      accessor: (action) => get(action, 'input.device_id', 'N/A'),
      Header: 'Device ID',
      Cell: (row) => {
        return <div className={styles.cellText}>{row.value || 'N/A'}</div>;
      },
      className: styles.cell
    },
    // TODO: wait until Action History API response returns along with user info
    // {
    //   id: 'user',
    //   sortable: true,
    //   minWidth: 80,
    //   accessor: (action) => get(action, 'userId', 'N/A'),
    //   Header: 'User',
    //   Cell: (row) => {
    //     return <div className={styles.cellText}>{row.value || 'N/A'}</div>;
    //   },
    //   className: styles.cell
    // },
    {
      id: 'status',
      sortable: true,
      minWidth: 90,
      accessor: (action) => get(action, 'runtimeStatus', 'N/A'),
      Header: 'Process Status',
      Cell: (row) => {
        const isFailedStatus = row.value === 'Failed';
        return <div className={isFailedStatus ? styles.failedCellText : styles.cellText}>{row.value || 'N/A'}</div>;
      },
      className: styles.cell
    },
    {
      id: 'dmStatus',
      sortable: true,
      minWidth: 80,
      accessor: (action) => get(action, 'customStatus.status_info.dmStatus', '-'),
      Header: 'Direct Method',
      Cell: (row) => {
        return <div className={styles.cellText}>{row.value}</div>;
      },
      className: styles.cell
    },
    {
      id: 'validationStatus',
      sortable: true,
      minWidth: 80,
      accessor: (action) => get(action, 'customStatus.status_info.validationStatus', '-'),
      Header: 'Validation',
      Cell: (row) => {
        return <div className={styles.cellText}>{row.value}</div>;
      },
      className: styles.cell
    },
    {
      id: 'time_initiated',
      sortable: true,
      minWidth: 100,
      accessor: (action) => get(action, 'createdTime', 'N/A'),
      Header: 'Time - Initiated',
      Cell: (row) => {
        return <div className={styles.cellText}>{row.value || 'N/A'}</div>;
      },
      className: styles.cell
    },
    {
      id: 'time_completed',
      sortable: true,
      minWidth: 100,
      accessor: (action) => get(action, 'lastUpdatedTime', 'N/A'),
      Header: 'Time - Completed',
      Cell: (row) => {
        return <div className={styles.cellText}>{row.value || 'N/A'}</div>;
      },
      className: styles.cell
    }
  ].filter(Boolean);
};
